/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { useTicketPropertyDefinitions } from 'conversations-inbox-lib/tickets/hooks/useTicketPropertyDefinitions';
import { useUpdateTicketProperties } from 'conversations-inbox-lib/tickets/mutations/useUpdateTicketProperties';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import emptyFunction from 'react-utils/emptyFunction';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Con... Remove this comment to see the full error message

import UITruncateString from 'UIComponents/text/UITruncateString';
// @ts-expect-error ts-migrate(1192) FIXME: Module not found
import Raven from 'raven-js';
import { getChangeTicketProperty } from '../constants/events';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const inputProps = {
  buttonUse: 'transparent',
  use: 'transparent',
  multiCollapseLimit: 1,
  placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-help-desk.ticket-toolbar.ticketOptions.default.placeholder"
  }),
  valueComponent: ({
    option
  }) => /*#__PURE__*/_jsx(UITruncateString, {
    useFlex: true,
    children: option.text
  }),
  menuWidth: 250,
  dropdownFooter: /*#__PURE__*/_jsx(_Fragment, {})
};
const getDraftValue = emptyFunction.thatReturns(undefined);
const useTicketPipelineStageV2 = (ticket, trackEvent) => {
  const ticketId = ticket.id;
  const definitionsResults = useTicketPropertyDefinitions(['hs_pipeline_stage']);
  const componentLoading = definitionsResults.loading;
  const propertyList = definitionsResults.propertyDefinitions;
  const {
    updateTicketProperties
  } = useUpdateTicketProperties({
    ticketId
  });
  const stageProperty = useMemo(() => propertyList && propertyList.find(property => property.name === 'hs_pipeline_stage'), [propertyList]);
  const getSavedValue = useCallback(propertyName => {
    if (Object.prototype.hasOwnProperty.call(ticket.defaultProperties, propertyName)) {
      return ticket.defaultProperties[propertyName].value;
    }
    const propertyValue = ticket.properties.find(_ => _.name === propertyName);
    return propertyValue ? propertyValue.value : undefined;
  }, [ticket]);
  const onChange = useCallback(propertyChanges => {
    trackEvent(getChangeTicketProperty('hs_pipeline_stage'));
    const updatedProperties = Object.keys(propertyChanges).map(propertyName => ({
      name: propertyName,
      value: propertyChanges[propertyName] || undefined
    }));
    updateTicketProperties({
      onSuccess: () => {},
      onError: error => {
        Raven.captureException(new Error(error));
      },
      properties: updatedProperties
    });
  }, [updateTicketProperties, trackEvent]);
  return {
    componentLoading,
    stageProperty,
    getSavedValue,
    onChange
  };
};
const TicketPipelineStageV2 = ({
  ticket,
  trackEvent,
  dropdownFooter
}) => {
  const ticketId = ticket.id;
  const currentUserCanEdit = ticket.userPermissions.currentUserCanEdit;
  const {
    componentLoading,
    stageProperty,
    getSavedValue,
    onChange
  } = TicketPipelineStageV2.useComponent(ticket, trackEvent);
  inputProps.dropdownFooter = dropdownFooter;
  if (componentLoading) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "loading-state",
      children: /*#__PURE__*/_jsx(SkeletonBox, {
        height: "1em",
        width: "50%"
      })
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(PropertyInputV2, {
      objectTypeId: TICKET_TYPE_ID,
      objectId: `${ticketId}`,
      property: stageProperty,
      value: ticket.defaultProperties[stageProperty.name].value,
      getSavedValue: getSavedValue,
      getDraftValue: getDraftValue,
      disabled: !currentUserCanEdit,
      onChange: onChange,
      className: "p-left-0 p-bottom-0  p-top-0",
      inputProps: inputProps,
      enableConditionalPropertiesPanel: true,
      enableConditionalPropertyOptions: true,
      disableValidation: true,
      showAutoSaveText: true,
      use: "inline"
    })
  });
};
TicketPipelineStageV2.displayName = 'TicketPipelineStageV2';
TicketPipelineStageV2.useComponent = useTicketPipelineStageV2;
export default TicketPipelineStageV2;